// Renders shipping and delivery dates inside elements with data-delivery-timeline.
// Steps:
//  - Today (order placed)
//  - Today + 2..4 days (order ships)
//  - Today + 7..10 days (delivered)

/**
 * @param {Date} date
 * @param {number} days
 */
function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

/**
 * @param {Date} startDate
 * @param {Date} endDate
 */
function formatRange(startDate, endDate) {
  // Example: Nov 10 to Nov 15 (short month)
  const sameMonth = startDate.getMonth() === endDate.getMonth();
  const monthShort = new Intl.DateTimeFormat(undefined, { month: "short" });
  const startM = monthShort.format(startDate);
  const endM = monthShort.format(endDate);
  const startD = startDate.getDate();
  const endD = endDate.getDate();
  return sameMonth
    ? `${startM} ${startD} to ${endD}`
    : `${startM} ${startD} to ${endM} ${endD}`;
}

/**
 * @param {HTMLElement} container
 */
function updateOneTimeline(container) {
  const today = new Date();
  const shipStart = addDays(today, 2);
  const shipEnd = addDays(today, 4);
  const deliverStart = addDays(today, 7);
  const deliverEnd = addDays(today, 10);

  const shipEl = container.querySelector("[data-ship-range]");
  const deliverEl = container.querySelector("[data-deliver-range]");
  const rangeEl = container.querySelector("[data-range]");
  if (shipEl) shipEl.textContent = formatRange(shipStart, shipEnd);
  if (deliverEl) deliverEl.textContent = formatRange(deliverStart, deliverEnd);
  if (rangeEl) rangeEl.textContent = formatRange(deliverStart, deliverEnd);
}

function initDeliveryTimelines(root = document) {
  const containers = Array.from(
    root.querySelectorAll("[data-delivery-timeline]")
  );
  containers.forEach(updateOneTimeline);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initDeliveryTimelines());
} else {
  initDeliveryTimelines();
}
